import { createAction, props } from '@ngrx/store';
import { Game } from '@app/games/model/game';

const TAG = '[Games]';


export const loadGames = createAction(`${TAG} Load games`, props<{ language: string }>());
export const gamesLoaded = createAction(`${TAG} Games loaded`, props<{ games: Game[] }>());

